import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export function minDateValidator(minDateValue: any): ValidatorFn {
  const minDate = moment(minDateValue);
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const date = moment(control.value);
    const isValid = date.isSameOrAfter(minDate);
    return isValid ? null : { minDate: true };
  };
}

export function maxDateValidator(maxDateValue: any): ValidatorFn {
  const maxDate = moment(maxDateValue);
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const date = moment(control.value);
    const isValid = date.isBefore(maxDate);
    return isValid ? null : { maxDate: true };
  };
}
